function o(e) {
  try {
    const t = sessionStorage.getItem(`chatbot-${e}-session`);
    return t ? JSON.parse(t) : null;
  } catch (t) {
    return console.warn("Error getting chat session info from session storage", t), null;
  }
}
function i(e, t) {
  let s = o(e);
  (s == null ? void 0 : s.sessionId) !== t.sessionId && (s = null);
  const n = {
    ...s,
    ...t
  };
  try {
    sessionStorage.setItem(
      `chatbot-${e}-session`,
      JSON.stringify(n)
    );
  } catch (r) {
    console.warn("Error setting chat session info in session storage", r);
  }
}
function a(e, t) {
  const s = o(e);
  s && (s.usedSuggestions = [
    ...s.usedSuggestions || [],
    t
  ], i(e, s));
}
function d() {
  try {
    const e = sessionStorage.getItem(
      "embedded-chatbot-state"
    );
    return e ? JSON.parse(e) : null;
  } catch (e) {
    return console.warn(
      "Error getting embedded chatbot state from session storage",
      e
    ), null;
  }
}
function c(e) {
  try {
    sessionStorage.setItem("embedded-chatbot-state", JSON.stringify(e));
  } catch (t) {
    console.warn(
      "Error setting embedded chatbot state in session storage",
      t
    );
  }
}
export {
  a as appendCurrentChatSessionUsedSuggestions,
  o as getCurrentChatSessionInfo,
  d as getEmbeddedChatbotState,
  i as setCurrentChatSessionInfo,
  c as setEmbeddedChatbotState
};
